import styled from 'styled-components';

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 20px;
  margin-left: 8px;
  padding: 0 5px 0 8px;
  border-radius: 999px;
  background: rgba(237, 187, 52, 0.22);
  color: #f0bb34;
  font-size: 10px;
  font-weight: 800;
  font-family: var(--google-sora-cdn);
  letter-spacing: 0.06em;
  line-height: 1;
  text-transform: uppercase;
  vertical-align: middle;
  box-sizing: border-box;
`;

export const BadgeLabel = styled.span`
  display: inline-flex;
  align-items: center;
  height: 14px;
  line-height: 14px;
`;

export const BadgeInfo = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;

  button {
    width: 14px;
    height: 14px;
    margin-left: 0;
    background-color: #fdb41f !important;
    color: #000;
  }

  svg {
    width: 3px;
  }
`;

export const Popup = styled.div`
  width: 280px;
  padding: 18px 20px 12px;
`;

export const Title = styled.div`
  margin-bottom: 8px;
  color: var(--text-color);
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
`;

export const Description = styled.p`
  margin: 0 0 10px;
  color: var(--text-color-medium-gray);
  font-size: 12px;
  line-height: 1.45;
`;

export const MoreInfoLink = styled.a`
  display: inline-block;
  margin-bottom: 18px;
  color: var(--text-color);
  font-size: 12px;
  line-height: 1.4;
  text-decoration: underline;

  &:hover {
    opacity: 0.85;
  }
`;

export const OptionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
`;

export const OptionLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-color);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

export const OptionHint = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;
  text-transform: none;
  font-weight: 400;
  letter-spacing: 0;

  button {
    width: 14px;
    height: 14px;
    margin-left: 0;
  }

  svg {
    width: 3px;
  }
`;
